"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var WorkIndicator_1 = __importDefault(require("./WorkIndicator"));
var Image = styled_components_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 100%;\n\theight: 100%;\n\tvisibility: ", ";\n"], ["\n\twidth: 100%;\n\theight: 100%;\n\tvisibility: ", ";\n"])), function (props) { return props.loaded ? "visible" : "hidden"; });
var PromisedImage = /** @class */ (function (_super) {
    __extends(PromisedImage, _super);
    function PromisedImage(props) {
        var _this = _super.call(this, props) || this;
        _this.maybeShowSpinner = function () {
            if (!_this.state.imageLoaded) {
                // its been however long and the image isn't ready, so show a spinner
                _this.setState({ showSpinner: true });
            }
        };
        _this.imageLoaded = function () {
            _this.setState({ imageLoaded: true });
        };
        _this.imageError = function () {
            console.log("Error loading image");
            _this.setState({ errorState: true });
        };
        _this.state = {
            timer: null,
            resolvedURL: null,
            imageLoaded: false,
            showSpinner: false,
            errorState: false
        };
        _this._isMounted = false;
        return _this;
    }
    PromisedImage.prototype.componentDidMount = function () {
        var _this = this;
        this._isMounted = true;
        this.setState({
            timer: setTimeout(this.maybeShowSpinner, 300),
        });
        if (this.props.promise) {
            this.props.promise().then(function (url) {
                if (_this._isMounted) {
                    _this.setState({ resolvedURL: url });
                }
            }).catch(function (err) {
                console.log("PromisedImage promise fail", err);
                if (_this._isMounted) {
                    _this.setState({ errorState: true });
                }
            });
        }
    };
    PromisedImage.prototype.componentWillUnmount = function () {
        if (this.state.timer) {
            clearTimeout(this.state.timer);
        }
        this._isMounted = false;
    };
    PromisedImage.prototype.render = function () {
        var imgComp = null;
        if (this.state.resolvedURL) {
            imgComp = (react_1.default.createElement(Image, { alt: this.props.alt, loaded: this.state.imageLoaded, src: this.state.resolvedURL, onLoad: this.imageLoaded, onError: this.imageError }));
        }
        if (this.state.errorState) {
            return (react_1.default.createElement("div", { style: { backgroundColor: "#eee", width: "100%", height: "100%" } }));
        }
        return (react_1.default.createElement("div", { style: { width: "100%", height: "100%", position: "relative" } },
            (!this.state.imageLoaded && this.state.showSpinner) &&
                react_1.default.createElement(WorkIndicator_1.default, null),
            imgComp));
    };
    return PromisedImage;
}(react_1.Component));
exports.default = PromisedImage;
var templateObject_1;
//# sourceMappingURL=PromisedImage.js.map